import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'
import { CONTACT_API } from '../../api/contact-api'
import { ContactBulkInterface } from '../../types/contact-menu-interface'

export const useContactsBulkRestore = () => {
  const { fetcher, isFetching } = useFetch({
    method: RequestMethodsEnum.post,
  })
  return {
    contactsBulkRestore: (data: ContactBulkInterface) =>
      fetcher(`${CONTACT_API}/bulk-actions/bulk-restore`, data, {
        headers: {
          'X-Violation-Response-Format': 'Rfc7807',
        },
      }),
    isFetching,
  }
}
